import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { store } from "./store";
import * as Sentry from '@sentry/browser';
import InternalServer from './lib/components/ErrorPages/InternalServer/InternalServer';
import ErrorBoundary from 'react-error-boundary';

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: "https://860b53771ff545ce93b57cc43c683f92@sentry.io/1852305",
        environment: process.env.NODE_ENV,
    });
}

ReactDOM.render(
    <Provider store={store}>
        <ErrorBoundary FallbackComponent={InternalServer} >
            <App />
        </ErrorBoundary>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
